import { render, staticRenderFns } from "./SquareFilter.vue?vue&type=template&id=824638d6&scoped=true&"
import script from "./SquareFilter.vue?vue&type=script&lang=js&"
export * from "./SquareFilter.vue?vue&type=script&lang=js&"
import style0 from "./SquareFilter.vue?vue&type=style&index=0&id=824638d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824638d6",
  null
  
)

export default component.exports